import React, { Component } from 'react';
import { connect } from "react-redux";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class FilterVariable extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;

        return (

            <div style={{"position":"absolute"}} >
                <div className="dropdown-livechat">

                    <div
                         className="dropdown-livechat-content dropdown-filter-livechat-content"
                    >
                        {Object.keys(this.props.stateFilter).map(key=> {

                        if(this.props.propFilter.filter(f=>f==this.props.stateFilter[key].name).length>0) {
                            return <a
                                onClick={e=>this.props.selectFilter(e, this.props.stateFilter[key].name)}
                            >
                                <div className="dropdown-livechat-item-content">
                                    <div className="dropdown-livechat-item-content_icon"><i
                                        className={this.props.stateFilter[key].icon}></i></div>
                                    <div
                                        className="dropdown-livechat-item-content_title">{this.props.stateFilter[key].name}</div>
                                </div>
                            </a>

                        }})}
                    </div>
                </div>
            </div>

        );
    }
}

export default FilterVariable;
